import React from 'react';

import { ReactComponent as Calendar } from 'assets/icons/automatic-buy-calendar.svg';

const BuyInstructionContent = (accountName) => {
  return {
    title: 'Buy shares with a bank account',
    subtitle: <span>Before you start investing, you must first transfer assets into your brokerage sweep account by buying shares of <span id="funding-modal-step-2-accountName">{accountName}</span>.</span>,
    steps: [
      {
        content:
          'Link a bank securely using your login credentials or your routing and account numbers'
      },
      {
        content:
          'Add money to your sweep account to buy shares of an investment'
      }
    ],
    notes: [
      {
        moneyMarketContent: 'Trade requests made during market hours are generally processed the same day at 5 p.m. ET. You will be able to purchase shares of brokerage investments using assets held in your sweep account.',
        content:
          'Trade requests made during market hours are generally processed the same day at 4 p.m. ET. You will be able to purchase shares of brokerage investments using assets held in your sweep account.',
        icon: <Calendar />
      }
    ]
  };
};

export default BuyInstructionContent;
